module.exports = __webpack_public_path__ + "img/bloopers_thumb.501b3106.jpg";